<template>
  <div class="ui-field">
    <label v-if="label" class="ui-field__label" :for="forId">{{ label }}</label>

    <slot />

    <p v-if="hint" :id="forId ? `${forId}-hint` : undefined" class="ui-field__hint">{{ hint }}</p>

    <p v-if="error" :id="forId ? `${forId}-error` : undefined" class="ui-field__error" role="alert">
      {{ error }}
    </p>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    label?: string;
    forId?: string;
    hint?: string;
    error?: string;
  }>(),
  {
    label: undefined,
    forId: undefined,
    hint: undefined,
    error: undefined,
  },
);
</script>
